import React from 'react';
import { Header } from '../../Layout/Header/Header';
import { Main } from '../../Layout/Main/Main';

export const Home = () => {
  return (
    <div>
      <Header/>
      <Main/>
    </div>
  )
}
